import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { KycserviceService } from "../services/kycservice.service";
import {
  DomSanitizer,
  SafeResourceUrl,
  SafeUrl,
} from "@angular/platform-browser";
import { UserService } from "../services/user.service";
import { Router, ActivatedRoute } from "@angular/router";
import { RoutingstateService } from "../services/routingstate.service";
import { NotificationsService } from "angular2-notifications";
import { Location } from "@angular/common";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { AssetsService } from "../services/assets.service";
import { PuserserviceService } from "../services/puserservice.service";
import { PagerserviceService } from "../services/pagerservice.service";
import { environment } from "../../environments/environment";
import { Globals } from "../app-globals";
import { AdminService } from "../services/admin.service";
import csc from "country-state-city";
import { AppKycDetailsService } from "./appkycdetails.service";
import * as moment from 'moment';
import * as _html2canvas from "html2canvas";
import { HttpClient, HttpHeaders } from "@angular/common/http";
const html2canvas: any = _html2canvas;
@Component({
  selector: "app-appkycdetails",
  templateUrl: "./appkycdetails.component.html",
  styleUrls: ["./appkycdetails.component.css"],
})
export class AppkycdetailsComponent implements OnInit {
  token: string;
  kycList: Array<any>;
  kycListById: {};
  actionKycListPerformed: Boolean;
  actionKycViewPerformed: Boolean;
  imgpreview: Boolean;
  kycModal: Boolean;
  pdfpreview: Boolean;
  imgpreviewUrl: SafeResourceUrl;
  pdfpreviewUrl: SafeResourceUrl;
  kycActive: String;
  customerId: any;
  sumsubStatus: any;
  sumsubObj:any = {
    applicantClientReason:'',
    applicantModerateReason:''
  };
  applicantId : any;
  urlObj : any;
  userId : any;
  /* pagenation */
  // pager Number
  pager: number;
  Tpager: number;
  // paged items
  pagedItems: Array<any>;
  // next status
  nextdisable: Boolean;
  nextActive: Boolean;

  // previous  Status
  previousActive: Boolean;
  previousDisable: Boolean;

  /*Filter variables*/
  serach: string;
  FilPerpage: number;
  FilPage: number;

  // pager object
  pager1: any = {};

  /*
          back end application api url
       */
  api_url: string = environment.apiEndPoint;
  permission: String;
  customer: Boolean;
  addressObj = {
    address: "",
    country: "",
    state: "",
    city: "",
    postalcode: "",
  };
  currentItem = {
    address: "",
    country: null,
    state: null,
    city: null,
    postalcode: "",
  };
  totalRecords = 0;
  kyc: any = {};
  udo_detail: any;
  user_detail: any;
  date: any;
  data: any;
  sanctionList: any;
  categories: any;
  userList: any;
  name: any;
  dob: any;
  country: any;
  gender: any;
  userid: any;
  status: any;
  csrf: any;


  /* Sumsub */
  legalName : any;
  ApplicantEmail : any;
  ApplicantDob : any;
  phone : any;
  ApplicantGender : any;
  Applicantcountry : any;
  reviewStatus : any;
  constructor(
    private userService: UserService,
    private _location: Location,
    private KycserviceService: KycserviceService,
    private router: Router,
    private routingState: RoutingstateService,
    private notifSer: NotificationsService,
    private spinnerService: Ng4LoadingSpinnerService,
    private sanitizer: DomSanitizer,
    private assetsService: AssetsService,
    private pusherService: PuserserviceService,
    private pagerService: PagerserviceService,
    private adminService: AdminService,
    private route: ActivatedRoute,
    private appKyc: AppKycDetailsService,
    public http : HttpClient
  ) {}

  ngOnInit() {
    if (!this.userService.isLoggedIn()) {
      this.router.navigateByUrl("/index");
    } else {
      this.adminService.groupupdate.subscribe((permData) => {
        localStorage.setItem("permission", permData.permission);
        this.permission = permData.permission;
      });
      this.permission = this.adminService.getPermission();
      this.customer = false;
      this.serach = "";
      this.FilPerpage = 10;
      this.FilPage = 1;
      this.pager = 1;
      this.serach = this.route.snapshot.paramMap.get("id");
      this.getKycDetails();
      this.kycActive = null;
      this.imgpreviewUrl = null;
      this.pdfpreviewUrl = null;
      this.kycModal = false;
      this.pdfpreview = false;
      this.imgpreview = false;

      // this.pusherService.channel.bind('kyc-notification-add', data => {
      //     this.getKycDetails();
      //     this.notifSer.success(
      //         'Success',
      //         'Kyc has received new kyc record',
      //         {
      //             timeOut: 3000,
      //             showProgressBar: true,
      //             pauseOnHover: false,
      //             clickToClose: true,
      //             maxLength: 50
      //         }
      //     )
      // });
    }
  }

  kycViewDetails(id, item) {
    this.kycActive = id;
    this.addressObj = {
      address: "",
      country: "",
      state: "",
      city: "",
      postalcode: "",
    };
    if (
      typeof item.address !== "undefined" &&
      item.address &&
      item.address != ""
    ) {
      this.addressObj.address = item.address;
    }
    if (
      typeof item.country !== "undefined" &&
      item.country &&
      item.country != ""
    ) {
      var country = csc.getCountryById(item.country);
      this.addressObj.country = country.name;
    }
    if (typeof item.state !== "undefined" && item.state && item.state != "") {
      var state = csc.getStateById(item.state);
      this.addressObj.state = state.name;
    }
    if (typeof item.city !== "undefined" && item.city && item.city != "") {
      var city = csc.getCityById(item.city);
      this.addressObj.city = city.name;
    }
    if (
      typeof item.postalcode !== "undefined" &&
      item.postalcode &&
      item.postalcode != ""
    ) {
      this.addressObj.postalcode = item.postalcode;
    }
  }

  kycViewDetailshide() {
    this.kycActive = null;
  }

  goBack() {
    //this._location.back();
    this.actionKycListPerformed = true;
    this.actionKycViewPerformed = false;
  }

  id;
  getKycDetails() {
    this.spinnerService.show();
    this.KycserviceService.getKycList(this.serach).subscribe(
      (list) => {
        var { _id, name, gender, dob, country } = list.kyclist[0].userdet;
        this.customerId = _id;
        name = name.charAt(0).toUpperCase() + name.slice(1);
        gender = gender.charAt(0).toUpperCase() + gender.slice(1);
        dob = dob ? dob.split("-").reverse().join("-") : '';
        if (list.status) {
          this.actionKycListPerformed = true;
          this.actionKycViewPerformed = false;
          this.kyc = list.kyclist[0];
          this.udo_detail = this.kyc.userdet.ubo[0];
          this.user_detail = this.kyc.userdet;
        }
        this.spinnerService.hide();
        this.userService.csrf().subscribe((resp) => {
          this.csrf = resp._csrf;
        });
        
        this.appKyc.getApplicants(_id).subscribe((res : any) => { 
          this.applicantId = res.id;
          this.userId = res.externalUserId;
          this.token = localStorage.getItem(environment.TOKEN_SECRET);
          const headers = {              
            Authorization: `Bearer ${this.token}`,
          };
          this.appKyc.getApplicantsStatus(res.id).subscribe((res : any) => {
            this.sumsubStatus = res.reviewStatus;
            this.http.get(`${environment.apiEndPoint}summary-report?applicantId=${this.applicantId}`,{ headers:headers, observe: 'response', responseType: 'blob' }, ).subscribe((res:any)=>{              
              const pdfData = URL.createObjectURL(res.body)
              this.urlObj = this.sanitizer.bypassSecurityTrustUrl(pdfData)
          });
            if(res.reviewResult) {             
              this.sumsubObj = {
               userId : this.userId,
               applicantStatus :res.reviewResult.reviewAnswer,
               _csrf : this.csrf
              }
              if(res.reviewResult && res.reviewResult.rejectLabels) {
                this.sumsubObj['applicantClientReason'] = res.reviewResult.rejectLabels[0]
                this.sumsubObj['applicantModerateReason'] = res.reviewResult.rejectLabels[1]
              }
              this.appKyc.updateApplicant(this.sumsubObj).subscribe((res : any) => {
                if(res.data.applicantStatus && res.data.applicantStatus === 'GREEN') {
                  return this.sumsubStatus = 'Approved';
                } else if(res.data.applicantStatus && res.data.applicantStatus == 'RED') {
                  return this.sumsubStatus = 'Rejected';
                } else {
                  this.appKyc.getSumsubStatus(_id).subscribe(res => {
                    if(res.data.status == 'pending') return this.sumsubStatus = res.data.status
                  })
                }
                
              })
            }
          });
        })
        
      },
      (err) => {
        this.spinnerService.hide();
        this.notifSer.error("Error", err.error.message, {
          timeOut: 3000,
          showProgressBar: true,
          pauseOnHover: false,
          clickToClose: true,
          maxLength: 50,
        });
      }
    );   
  }
  convertToCamelCaseWithSpaces = (text: any) => {
    if (!text) return '';

    return text
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (char: any) => char.toUpperCase())
      .trim();
  }
  kycVerify(id) {
    if (window.confirm("Are you sure want to verify this kyc ?")) {
      this.spinnerService.show();
      this.KycserviceService.getKycVerifyById(id).subscribe(
        (result) => {
          this.getKycDetails();
          this.notifSer.success("Success", "Kyc has been verified", {
            timeOut: 3000,
            showProgressBar: true,
            pauseOnHover: false,
            clickToClose: true,
            maxLength: 50,
          });
          this.spinnerService.hide();
        },
        (err) => {
          this.spinnerService.hide();
          this.notifSer.error("KYC Error", err.message, {
            timeOut: 3000,
            showProgressBar: true,
            pauseOnHover: false,
            clickToClose: true,
            maxLength: 50,
          });
        }
      );
    } else {
      return false;
    }
  }

  kycReject(id) {
    if (window.confirm("Are you sure want to reject this kyc ?")) {
      this.spinnerService.show();
      var obj = {
        id: id,
        reason: this.kyc.reason || '',
      };
      this.KycserviceService.setKycReject(obj).subscribe(
        (result) => {
          this.getKycDetails();
          this.spinnerService.hide();
          this.notifSer.success("Success", "Kyc has been rejected", {
            timeOut: 3000,
            showProgressBar: true,
            pauseOnHover: false,
            clickToClose: true,
            maxLength: 50,
          });
        },
        (err) => {
          this.spinnerService.hide();
          this.notifSer.error("KYC Error", err.message, {
            timeOut: 3000,
            showProgressBar: true,
            pauseOnHover: false,
            clickToClose: true,
            maxLength: 50,
          });
        }
      );
    } else {
      return false;
    }
  }

  kycRemove(id) {
    if (
      window.confirm(
        "Customer KYC will reset to level 1, Are you sure want to remove?"
      )
    ) {
      this.spinnerService.show();
      this.KycserviceService.setKycRemove(id).subscribe(
        (result) => {
          this.spinnerService.hide();
          this.getKycDetails();
          this.notifSer.success("Success", "Kyc has been Removed", {
            timeOut: 3000,
            showProgressBar: true,
            pauseOnHover: false,
            clickToClose: true,
            maxLength: 50,
          });
        },
        (err) => {
          this.spinnerService.hide();
          this.notifSer.error("KYC Error", err.message, {
            timeOut: 3000,
            showProgressBar: true,
            pauseOnHover: false,
            clickToClose: true,
            maxLength: 50,
          });
        }
      );
    } else {
      return false;
    }
  }

  kycPending(id) {
    if (window.confirm("Are you sure want to pending this kyc ?")) {
      this.spinnerService.show();
      this.KycserviceService.kycPending(id).subscribe(
        (list) => {
          this.spinnerService.hide();
          this.getKycDetails();
          this.notifSer.success("Success", "Kyc has been deactivated", {
            timeOut: 3000,
            showProgressBar: true,
            pauseOnHover: false,
            clickToClose: true,
            maxLength: 50,
          });
        },
        (err) => {
          this.spinnerService.hide();
          this.notifSer.error("KYC Error", err.message, {
            timeOut: 3000,
            showProgressBar: true,
            pauseOnHover: false,
            clickToClose: true,
            maxLength: 50,
          });
        }
      );
    } else {
      return false;
    }
  }

  showKYCFile(url) {
    let ext = url.substr(url.lastIndexOf(".") + 1);
    let path = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.api_url + url
    );
    if (ext === "PDF" || ext === "pdf") {
      //this.pdfpreviewUrl = this.api_url+url;
      this.pdfpreviewUrl = path;
      this.imgpreview = false;
      this.pdfpreview = true;
    } else {
      //this.imgpreviewUrl = this.api_url+url;
      this.imgpreviewUrl = path;
      this.pdfpreview = false;
      this.imgpreview = true;
    }
  }

  sreach(event: any) {
    // this.serach = event.target.value;
    this.getKycDetails();
  }
  // updateUrl(event,key){
  //     if(key == 'front'){
  //         this.kyc.front = event
  //     }
  //     if(key == 'back'){
  //         this.kyc.back = event
  //     }
  // }
}



// WEBPACK FOOTER //
// ./src/app/appkycdetails/appkycdetails.component.ts